import { Controller } from 'react-hook-form'
import { BaseDocumentUpload } from '../editComponents/baseDocumentUpload'
import { withTierPermission } from '../HOC/withTierPermission'

interface IFormUploadDocsProps {
    control: any
    name: string
    fieldLabel?: string
}

export const FormUploadDocs = ({
    control,
    name,
    fieldLabel,
}: IFormUploadDocsProps) => {
    return (
        <Controller
            name={name}
            control={control}
            render={({ field: { onChange, value }, fieldState: { error } }) => {
                return (
                    <BaseDocumentUpload
                        fieldLabel={fieldLabel}
                        onChange={onChange}
                        value={value}
                    />
                )
            }}
        />
    )
}
export const PremiumFormUploadDocs = withTierPermission(FormUploadDocs, {
    requiredTier: ['enterprise'],
})
